export const enum AvailableDialogs {
    NONE = 'none',
    SHARE = 'share',
    EDIT = 'edit',
    DELETE = 'delete',
}
